import PanelContainer from './PanelContainer'
import TabContainer from './TabContainer'

TabContainer.PanelContainer = PanelContainer

export default TabContainer
